import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class MetricCounterEndpoint extends BaseEndpoint {}
